export const SET_ALL_PAYOUTS = 'SET_ALL_PAYOUTS';
export const GET_ALL_PAYOUTS = 'GET_ALL_PAYOUTS';

export const GET_SINGLE_PAYOUTS = 'GET_SINGLE_PAYOUTS';
export const SET_SINGLE_PAYOUTS = 'SET_SINGLE_PAYOUTS';

export const GETTING_SETTLEMENT_ACCOUNT = 'GETTING_SETTLEMENT_ACCOUNT';
export const GETTING_SETTLEMENT_ACCOUNT_SUCCESS = 'GETTING_SETTLEMENT_ACCOUNT_SUCCESS';
export const GETTING_SETTLEMENT_ACCOUNT_FAILURE = 'GETTING_SETTLEMENT_ACCOUNT_FAILURE';

export const GET_SETTLEMENT_TRANSACTION = 'GET_SETTLEMENT_TRANSACTION';
export const GET_SETTLEMENT_TRANSACTION_SUCCESS = 'GET_SETTLEMENT_TRANSACTION_SUCCESS';
export const GET_SETTLEMENT_TRANSACTION_FAILURE = 'GET_SETTLEMENT_TRANSACTION_FAILURE';

export const GET_UNSETTLED_SETTLEMENTS = 'GET_UNSETTLED_SETTLEMENTS';
export const GET_UNSETTLED_SETTLEMENTS_SUCCESS = 'GET_UNSETTLED_SETTLEMENTS_SUCCESS';
export const GET_UNSETTLED_SETTLEMENTS_FAILURE = 'GET_UNSETTLED_SETTLEMENTS_FAILURE';

export const GET_SETLLEMENTS_ANALYTICS = 'GET_SETLLEMENTS_ANALYTICS';
export const GET_SETLLEMENTS_ANALYTICS_FAILURE = 'GET_SETLLEMENTS_ANALYTICS_FAILURE';
export const GET_SETTLEMENTS_ANALYTICS_SUCCESS = 'GET_SETTLEMENTS_ANALYTICS_SUCCESS';

export const DOWNLOAD_SETTLEMENT_CSV = 'DOWNLOAD_SETTLEMENT_CSV';
export const DOWNLOAD_SETTLEMENT_CSV_SUCCESS = 'DOWNLOAD_SETTLEMENT_CSV_SUCCESS';
export const DOWNLOAD_SETTLEMENT_CSV_FAILURE = 'DOWNLOAD_SETTLEMENT_CSV_FAILURE';